import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { FeeCalculationStatus } from '../../types/feeCalculation';

export const feeCalculationStatusToInfo: {
  [prop in FeeCalculationStatus]: {
    color: 'error' | 'info' | 'success' | 'warning';
    icon: React.ElementType;
    menuAction: string;
  };
} = {
  [FeeCalculationStatus.CREATED]: {
    color: 'info',
    menuAction: 'Change to Created',
    icon: InfoIcon,
  },
  [FeeCalculationStatus.APPROVED]: {
    color: 'success',
    menuAction: 'Approve',
    icon: CheckCircleIcon,
  },
  [FeeCalculationStatus.RETURNED_FOR_CORRECTION]: {
    color: 'warning',
    menuAction: 'Returned for correction',
    icon: WarningIcon,
  },
  [FeeCalculationStatus.REJECTED]: {
    color: 'error',
    menuAction: 'Reject',
    icon: CheckCircleIcon,
  },
  [FeeCalculationStatus.EXECUTING]: {
    color: 'success',
    menuAction: 'Execute',
    icon: CheckCircleIcon,
  },
  [FeeCalculationStatus.DONE]: {
    color: 'success',
    menuAction: 'Change to Done',
    icon: CheckCircleIcon,
  },
  [FeeCalculationStatus.FAILED]: {
    color: 'error',
    menuAction: 'Change to Failed',
    icon: CheckCircleIcon,
  },
};
